import React from 'react';
import './ActionButton.css';

export default function ActionButton({ icon, title, subtitle, color, onClick }) {
  return (
    <button 
      className="action-button" 
      style={{ backgroundColor: color }}
      onClick={onClick}
    >
      <div className="action-icon">{icon}</div>
      <div className="action-text">
        <div className="action-title">{title}</div>
        {subtitle && <div className="action-subtitle">{subtitle}</div>}
      </div>
    </button>
  );
}
